import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Checkbox } from '@morressier/alembic';
import { FormFieldCheckbox as IFormFieldCheckbox } from '@publishing-engine/domain/types/article';
import { Flex } from '@chakra-ui/react';
import { parseStringWithLinks } from 'src/utils/parseStringWithLinks';
import { FieldLabel } from 'src/components/Field';
import FormFieldErrorMessage from 'src/components/FormField/common/FormFieldErrorMessage';

interface IAuthorDeclarationProps {
  config: IFormFieldCheckbox;
  isEditingAllowed?: boolean;
  journalName: string; 
}

const AuthorDeclaration: React.FC<IAuthorDeclarationProps> = ({
  config,
  isEditingAllowed = true,
  journalName,
}) => {
  const { register, watch, setValue } = useFormContext();

  const {
    name,
    params: { validations, labels },
    caseDataFields: { main: field },
  } = config;

  const isChecked = watch(field);

  useEffect(() => {
    if (isChecked && journalName === 'bjr') {
      setValue('preference.publishingModel.model', 'openAccess');
      setValue('preference.publishingModel.acknowledgeCharge', true);
    } else if (!isChecked && journalName === 'bjr') {
      setValue('preference.publishingModel', null);
    }
  }, [isChecked, setValue, journalName]);

  return (
    <Flex flexDirection="column" alignItems="flex-start" gap={2} width="100%">
      <FieldLabel
        isRequired={validations.required}
        label={labels.main}
        subText={labels.subtitle}
      />
      <Checkbox
        ariaLabel={labels.main}
        id={name}
        {...register(field, { required: validations.required })}
        isDisabled={!isEditingAllowed}
      >
        {parseStringWithLinks(labels.content || labels.subtitle)}
      </Checkbox>
      <FormFieldErrorMessage config={config} />
    </Flex>
  );
};

export default AuthorDeclaration;
